import { render, staticRenderFns } from "./MerchantHomepage.vue?vue&type=template&id=7a6fdf88&scoped=true&"
import script from "./MerchantHomepage.vue?vue&type=script&lang=js&"
export * from "./MerchantHomepage.vue?vue&type=script&lang=js&"
import style0 from "./MerchantHomepage.vue?vue&type=style&index=0&id=7a6fdf88&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6fdf88",
  null
  
)

export default component.exports